import React, { ComponentType } from 'react';

import { FeatureFlowProvider } from '../contexts/FeatureFlowContext';
import { UserProps } from './types';

function withContext(WrappedComponent: ComponentType<UserProps>) {
  function withContextWrapper(props: UserProps) {
    return (
      <FeatureFlowProvider>
        <WrappedComponent {...props} />
      </FeatureFlowProvider>
    );
  }
  return React.memo(withContextWrapper);
}

export default withContext;
